import { inject } from '@angular/core';
import { ApiDataAccess, Dictionary, HttpApiRepository, Result } from '@softline/core';
import { TIME_REPORT_DETAIL_RESOURCE_PATH } from '../arbeitsbericht.api';
import { TimeReport } from '../models/time-report.model';

export class TimeReportRepository extends HttpApiRepository<
  TimeReport,
  Result<TimeReport>,
  { id: number },
  { id: number }
> {
  protected override getCRUDPathParams(params: { id: number }): Dictionary<unknown> {
    return { id: params.id };
  }
  constructor() {
    super(inject(ApiDataAccess), TIME_REPORT_DETAIL_RESOURCE_PATH);
  }

  override getLoadPathParams(params: { id: number }): Dictionary<unknown> {
    return { id: params.id };
  }
}

